import { render } from "./InstructionsList.vue?vue&type=template&id=e2bfb9ae&scoped=true"
import script from "./InstructionsList.vue?vue&type=script&lang=js"
export * from "./InstructionsList.vue?vue&type=script&lang=js"

import "./InstructionsList.vue?vue&type=style&index=0&id=e2bfb9ae&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e2bfb9ae"]])

export default __exports__